export default "__VITE_ASSET__ilLr6JRB__"